import React, { useEffect, useState } from 'react';
import { showError, showSuccess } from 'utils';
import styles from './index.module.scss';
import { updateOrderItem } from 'services';

const UpdateOrderItemModal = props => {
  const [loading, setLoading] = useState<boolean>(false);
  const { orderItemToUpdate, onSuccess, toggleModal } = props;
  const [count, setCount] = useState<number>(0);
  const { orderItemId = '' } = orderItemToUpdate;
  
  useEffect(() => {
    setCount(orderItemToUpdate.count);
  }, []);

  const handleUpdateOrderItem = async () => {
    setLoading(true);
    try {
      await updateOrderItem(orderItemId, count);
      await onSuccess();
      const message = count <= 0 ? 'Order Item deleted successfully' : 'Order Item updated successfully';
      showSuccess(message);
      toggleModal();
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles['main-container']}>
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <div>
            <div className={styles['label']}>Update Item</div>
          </div>
          <i className={'fa fa-times'} onClick={toggleModal} />
        </div>
        <div className={styles['modal-body']}>
          <div>
            <div className={styles['label']}>Quantity</div>
            <input
              type={'number'}
              value={count}
              className={'form-control'}
              onChange={e => setCount(parseInt(e.target.value))}
            />
            <div className={styles['label']}>*set quantity as 0 to delete item</div>
          </div>
        </div>
        <div className={styles['modal-footer']}>
          <button
            className={styles['cancel-button']}
            onClick={toggleModal}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            onClick={handleUpdateOrderItem}
            className={styles['submit-button']}
            disabled={loading}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateOrderItemModal;
